import React from "react";
import { Helmet } from "react-helmet-async";
import { localeFontStylesheet } from "../../fonts/localization-fonts/localeFontStylesheet";
import { MARKETING_LOCALES, MarketingLanguage } from "../../marketing-content/marketingLocales";
import { useLandingTheme } from "../landing-page/LandingThemeContext";

/** Register a complete page head together, after its lazy page is available. A font-only Helmet
 * outside that boundary would remove the static SEO tags before the page can adopt them. */
export function MarketingDocumentHead({ language, children, onChangeClientState }: {
  language: MarketingLanguage;
  children: React.ReactNode;
  onChangeClientState?: React.ComponentProps<typeof Helmet>["onChangeClientState"];
}) {
  const theme = useLandingTheme();
  const locale = MARKETING_LOCALES[language];
  const localeFontsHref = localeFontStylesheet(locale.productLocale);
  return (
    <Helmet htmlAttributes={{ lang: locale.htmlLang, dir: locale.direction }} onChangeClientState={onChangeClientState}>
      {children}
      {theme.fontsHref && <link rel="stylesheet" href={theme.fontsHref} />}
      {localeFontsHref && <link rel="stylesheet" href={localeFontsHref} data-localization-fonts={locale.productLocale} />}
    </Helmet>
  );
}
